export default __webpack_public_path__ + "747c4fd85e0a4c64f5f3ee74acc62a37.png";